export default "__VITE_ASSET__6w5pdkgd__"